import { Get } from "./apiUtils";
import { PagedModel, DailyReport } from "../models";

const getDailyReportAsync = async (
  salesOrg: string,
  pageNo: number = 1,
  pageSize: number = 5,
  keyword: string = "",
  modality: number = 0
): Promise<PagedModel<DailyReport>> => {
  const response = await Get(
    `/api/report/dailyreport/linehandling?salesOrg=${salesOrg}&pageNo=${pageNo}&pageSize=${pageSize}&keyword=${keyword}&modality=${modality}`
  );
  const result = await response.json();
  return result;
};

const getDailyReportNominationAsync = async (
  salesOrg: string,
  pageNo: number = 1,
  pageSize: number = 5,
  keyword: string = "",
  modality: number = 1
): Promise<PagedModel<DailyReport>> => {
  const response = await Get(
    `/api/report/dailyreport/nomination?salesOrg=${salesOrg}&pageNo=${pageNo}&pageSize=${pageSize}&keyword=${keyword}&modality=${modality}`
  );
  const result = await response.json();
  return result;
};

const getStatusSummary = async () => {
  const response = await Get(`/api/Report/status/summary`);
  const result = await response.json();
  return result;
};

export const ReportApi = {
  getDailyReportAsync,
  getDailyReportNominationAsync,
  getStatusSummary,
};
